import { get } from './P3Api';

class CategoryCertificationApi {
  static async getCategoryCertifications(categoryId) {
    return get(`categories/${categoryId}/certifications`);
  }
}

export default CategoryCertificationApi;
